class SlideShowFadeComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

    this.initPages();

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);

    if (this.sliderItemsToShow.length < 2) return;

    this.currentPage = 0;
    this.render();
  }

  render() {
    if (!this.slider) return;

    const previousPage = this.currentPage;

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItemsToShow.length - 1
        ? 0
        : this.currentPage + 1;

    this.setActiveSlide(slideScrollPosition);
  }

  setActiveSlide(position) {
    this.currentPage = position;
    this.slider.querySelector('.slider__slide.active').classList.remove('active');
    this.sliderItemsToShow[position].classList.add('active');
  }
}

customElements.define('slideshow-fade-component', SlideShowFadeComponent);

class CookiesPopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.COOKIE_CONSENT = 'user_cookie_consent';
    this.exit = this.querySelector('.js-exit-modal');
    this.accept = this.querySelector('.cookie-consent__accept')

    window.Shopify.loadFeatures([
      {
        name: 'consent-tracking-api',
        version: '0.1',
      }
    ], this.errorCheck.bind(this));
  }

  disconnectedCallback() {
    this.exit.removeEventListener('click'.this.acceptCookie)
    this.accept.removeEventListener('click'.this.acceptCookie)
  }

  acceptCookie() {
    window.Shopify.customerPrivacy.setTrackingConsent(true, this.hideCookieConsent.bind(this));
  }

  errorCheck(error) {
    if (error) throw error;

    this.initCookieConsent();
  }

  hideCookieConsent() {
    this.classList.add('hidden');
  }

  initCookieConsent() {
    const shouldShowBanner = window.Shopify.customerPrivacy.shouldShowBanner();
    const currentVisitorConsent = window.Shopify.customerPrivacy.currentVisitorConsent();
    const consentIsEmpty = Object.values(currentVisitorConsent).every(value => value == '');

    if (shouldShowBanner && consentIsEmpty) this.showCookieConsent();
  }

  showCookieConsent() {
    this.classList.remove('hidden');
    this.exit.addEventListener('click', this.acceptCookie.bind(this));
    this.accept.addEventListener('click', this.acceptCookie.bind(this));
  }
}

customElements.define('cookies-popup', CookiesPopup);

class EmailPopup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    if (!document.cookie.split("; ").find((row) => row.startsWith("email_popup=hidden"))) {
      this.classList.remove('hidden');
    }

    this.exit = document.querySelector('.email-popup button');
    this.klaviyoForm = document.querySelector(".email-popup__newsletter-klaviyo");
    this.cookieConsent = document.querySelector(".cookie-consent");

    if (this.klaviyoForm) this.updateArrowForKlaviyoForm();

    if (this.cookieConsent) this.addExtraMarginToCookieConsent();

    this.exit.addEventListener('click', (e) => {
      this.hideEmailPopup();
      if (this.cookieConsent) this.removeExtraMarginToCookieConsent();
    });
  }

  disconnectedCallback() {
    this.exit.removeEventListener('click'.this.acceptCookie);
  }

  hideEmailPopup() {
    this.classList.add('hidden');
    this.arrowObserver.disconnect();
    document.cookie = "email_popup=hidden;max-age=604800;path=/"; //cookie expires in a week
  }

  updateArrowForKlaviyoForm() {
    // if klaviyo form button already added to DOM
    if (this.querySelector("form.klaviyo-form button")) {
      this.querySelector("form.klaviyo-form button").innerHTML = '<svg width="18" height="11" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.9459 0.5L17 5.5M17 5.5L11.9459 10.5M17 5.5L-9.94071e-09 5.5" stroke="white"/></svg>';
    }

    // checks if form button added to DOM and for re-renders of form
    this.arrowObserver = new MutationObserver((mutationList, observer) => {
      if (this.querySelector("form.klaviyo-form button") && this.querySelector("form.klaviyo-form button").innerHTML.includes('⟶')) {
        this.querySelector("form.klaviyo-form button").innerHTML = '<svg width="18" height="11" viewBox="0 0 18 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.9459 0.5L17 5.5M17 5.5L11.9459 10.5M17 5.5L-9.94071e-09 5.5" stroke="white"/></svg>';
      }
    });
    this.arrowObserver.observe(this.querySelector(".email-popup__newsletter-klaviyo"), { childList: true, subtree: true });
  }

  addExtraMarginToCookieConsent() {
    // if klaviyo form already added to DOM
    if (this.querySelector("form.klaviyo-form")) {
      this.cookieConsent.style.bottom = this.offsetHeight + 56 + "" + "px";
    }
    // if klaviyo form element not yet added to DOM
    else if (this.querySelector(".email-popup__newsletter-klaviyo")) {
      this.marginObserver = new MutationObserver((mutationList, observer) => {
        this.cookieConsent.style.bottom = this.offsetHeight + 56 + "" + "px";
        this.marginObserver.disconnect();
      });
      this.marginObserver.observe(this.querySelector(".email-popup__newsletter-klaviyo"), { childList: true, subtree: true });
    }
    // if not using klaviyo form
    else {
      this.cookieConsent.style.bottom = this.offsetHeight + 56 + "" + "px";
    };
  }

  removeExtraMarginToCookieConsent() {
    this.cookieConsent.style.bottom = "48px";
  }
}

customElements.define('email-popup', EmailPopup);

class HeroComponent extends HTMLElement {
  constructor() {
    super();

    document.addEventListener("DOMContentLoaded", this.loadDeferredMedia.bind(this));
    window.addEventListener('resize', this.loadDeferredMedia.bind(this));
  }

  connectedCallback() {
    const rootMargin = matchMedia('(min-width: 990px)').matches ? '-52px 0px 0px 0px' : '-70px 0px 0px 0px'
    const options = {
      rootMargin,
      threshold: [0, 0.25, 0.50, 0.75, 1],
    }

    const observer = new IntersectionObserver(this.iOCallback, options);

    if (this.dataset['index'] == '0') {
      observer.observe(this.previousElementSibling);
    }
  }

  iOCallback(entries, observer) {
    entries.forEach((entry) => {
      document.documentElement.classList.toggle('header--is-clear', entry.isIntersecting)

      console.log(entry);
    })
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }

  loadDeferredMedia() {
    const desktopMedia = this.querySelector('[data-media-id="desktop-video"]');
    const mobileMedia = this.querySelector('[data-media-id="mobile-video"]');

    if (window.matchMedia("(max-width: 749px)").matches) {
      mobileMedia.loadContent(true)
    } else {
      desktopMedia.loadContent(true)
    }
  }
}

customElements.define('hero-component', HeroComponent)

class FacetsObserver extends HTMLElement {
  constructor() {
    super();
    this.facetsWrapper = this.querySelector('.facets-wrapper')
  }

  connectedCallback() {
    const rootMargin = '-' + this.facetsWrapper.offsetHeight + 'px 0px 0px 0px'
    const options = {
      rootMargin: rootMargin,
      threshold: [0],
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!entry.isIntersecting && entry.boundingClientRect.top <= 0) {
          this.facetsWrapper.classList.add('facets--solid')
        } else {
          this.facetsWrapper.classList.remove('facets--solid')
        }
      });
    }, options);

    observer.observe(this);
  }
}

customElements.define('facets-observer', FacetsObserver)

class KlaviyoFooterNewsletter extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.updateArrowForKlaviyoForm();
  }

  disconnectedCallback() {
    this.arrowObserver.disconnect();
  }

  updateArrowForKlaviyoForm() {
    // if klaviyo form button already added to DOM
    if (this.querySelector("form.klaviyo-form button")) {
      this.querySelector("form.klaviyo-form button").innerHTML = '<svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.9459 1L17 6M17 6L11.9459 11M17 6L-9.94071e-09 6" stroke="#1A1A22"/></svg>';
    }

    // checks if form button added to DOM and for re-renders of form
    this.arrowObserver = new MutationObserver((mutationList, observer) => {
      if (this.querySelector("form.klaviyo-form button") && this.querySelector("form.klaviyo-form button").innerHTML.includes('⟶')) {
        this.querySelector("form.klaviyo-form button").innerHTML = '<svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.9459 1L17 6M17 6L11.9459 11M17 6L-9.94071e-09 6" stroke="#1A1A22"/></svg>';
      }
    });
    this.arrowObserver.observe(this, { childList: true, subtree: true });
  }
}

customElements.define('klaviyo-footer-newsletter', KlaviyoFooterNewsletter);


class RuadhScreenSaver extends HTMLElement {
  constructor() {
    super();

    this.xPosition = 1;
    this.yPosition = 1;
    this.xSpeed = 1;
    this.ySpeed = 1;
    this.fps = 120;

  }

  connectedCallback() {
    this.inactiveMouseTimeout = this.dataset.inactiveMouseTimeout

    this.image = this.querySelector('.logo-lockup');

    this.timeoutID = setTimeout(() => {
      this.initScreensaver();
    }, this.inactiveMouseTimeout)

    window.addEventListener('mousemove', () => {
      this.classList.remove('active');
      clearTimeout(this.timeoutID);
      clearInterval(this.intervalId);


      this.timeoutID = setTimeout(() => {
        this.initScreensaver();

      }, this.inactiveMouseTimeout)

    });

    requestAnimationFrame(() => {
      this.render();
    });
  }

  initScreensaver() {
    this.classList.add('active');

    this.xPosition = 1;
    this.yPosition = 1;

    this.intervalId = setInterval(() => {
      if (this.xPosition + this.image.clientWidth >= this.clientWidth || this.xPosition <= 0) {
        this.xSpeed = this.xSpeed * -1;
      }

      if (this.yPosition + this.image.clientHeight >= this.clientHeight || this.yPosition <= 0) {
        this.ySpeed = this.ySpeed * -1;
      }

      this.xPosition += this.xSpeed;
      this.yPosition += this.ySpeed;

      requestAnimationFrame(() => {
        this.render();
      });

    }, 1000 / this.fps);
  }

  resetCountdown() {
    setTimeout();
  }

  render() {
    this.image.style.transform = `translate(${this.xPosition}px, ${this.yPosition}px)`
  }
}

customElements.define('ruadh-screen-saver', RuadhScreenSaver)
